namespace SorAraBul.Web.Modules.Administration.User.RequestHandlers {
    export interface GetCreditResponse extends Serenity.ServiceResponse {
        Credit?: number;
    }
}
